import { render, staticRenderFns } from "./PermissionDescription.vue?vue&type=template&id=6c619b8e&scoped=true"
import script from "./PermissionDescription.vue?vue&type=script&lang=js"
export * from "./PermissionDescription.vue?vue&type=script&lang=js"
import style0 from "./PermissionDescription.vue?vue&type=style&index=0&id=6c619b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c619b8e",
  null
  
)

export default component.exports